import { functionsFetch } from './functionsClient';

export type BillingCycle = 'monthly' | 'annual';

export interface BillingPlan {
  id: string;
  tier: 'free' | 'pro';
  name: string;
  comment_summaries_limit: number | null;
  price_monthly_cents: number;
  price_annual_cents: number;
  stripe_price_id_monthly: string | null;
  stripe_price_id_annual: string | null;
}

export interface BillingSubscriptionPayload {
  subscription: null | {
    id: string;
    tier: string;
    tier_display_name: string;
    status: string;
    billing_cycle: BillingCycle;
    current_period_end: string | null;
    next_billing_date: string | null;
    cancel_at_period_end: boolean;
    canceled_at: string | null;
  };
  usage: {
    current_period: { comment_summaries: number };
    historical: Array<{
      period_start: string;
      period_end: string;
      comment_summaries: number;
    }>;
  };
  limit: { comment_summaries: number };
}

export interface StripeCardPaymentMethod {
  id: string;
  card: { brand: string; last4: string; exp_month: number; exp_year: number };
}

export interface InvoiceRow {
  id: string;
  created: number;
  amount_paid: number;
  currency: string;
  status: string | null;
  invoice_pdf: string | null;
  hosted_invoice_url: string | null;
}

export const billingApi = {
  async getPlans() {
    return await functionsFetch<{ plans: BillingPlan[] }>('/billing-plans', { method: 'GET' });
  },

  async getSubscription(periods = 6) {
    return await functionsFetch<BillingSubscriptionPayload>(`/billing-subscription?periods=${periods}`, { method: 'GET' });
  },

  async getPaymentMethod() {
    return await functionsFetch<{ payment_method: StripeCardPaymentMethod | null }>('/billing-payment-method', { method: 'GET' });
  },

  async getInvoices(params: { limit?: number; starting_after?: string } = {}) {
    const qs = new URLSearchParams();
    if (params.limit) qs.set('limit', String(params.limit));
    if (params.starting_after) qs.set('starting_after', params.starting_after);
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    return await functionsFetch<{ invoices: InvoiceRow[]; has_more: boolean }>(`/billing-invoices${suffix}`, { method: 'GET' });
  },
};


